const GENDER_MAP: Readonly<Record<string, "male" | "female">> = {
  women: "female",
  men: "male",
  female: "female",
  male: "male",
  kids: "female",
} as const;

export const fixFemaleOrMale = (
  gender: string | undefined
): "female" | "male" => {
  if (!gender) {
    return "female";
  }

  return GENDER_MAP[gender];
};
